import React from 'react'
import SMSPanel from '../SMSPanel/SMSPanel'
import LogsPanel from './LogsPanel'

export default function InformationsTab ({ slot, setSlot, style = {} }) {
  return (
    <div style={{ ...style, display: 'flex', justifyContent: 'space-between' }} >
      <div style={{ width: '47%' }} ><LogsPanel logs={slot.logs} date={slot.begin_date} /></div>
      <div style={{ width: '47%' }} ><SMSPanel owner={slot} ownerType="slots" setOwner={setSlot} /></div>
    </div>
  )
}
